import { ComponentPropsWithoutRef, forwardRef } from 'react';

import cn from '@/utils/cn';

import { cva } from 'class-variance-authority';

const addonCheckboxGroup = cva('', {
  variants: {
    layout: {
      horizontal: [
        'grid grid-cols-1 gap-3 md:grid-cols-2 md:flex-row md:gap-5.5',
      ],
      vertical: ['flex flex-col gap-3'],
    },
  },
});

interface AddonCheckboxGroupProps extends ComponentPropsWithoutRef<'div'> {
  layout?: 'horizontal' | 'vertical';
}

const AddonCheckboxGroup = forwardRef<HTMLDivElement, AddonCheckboxGroupProps>(
  ({ className, layout = 'vertical', ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="group"
        className={cn(addonCheckboxGroup({ layout }), className)}
        {...props}
      />
    );
  }
);
AddonCheckboxGroup.displayName = 'AddonCheckboxGroup';

export default AddonCheckboxGroup;
